enum ViewTypes {
    DRAFT_SELECTIONS = 'draft-selections',
    HISTORY = 'history',
    ROSTER = 'roster',
    SEASON_BY_SEASON_RECORD = 'season-by-season-record',
    ALL_TIME_RECORD_VS_FRANCHISE = 'all-time-record-vs-franchise',
    TEAM_DIRECTORY = 'team-directory',
}

const isHistoryView = (view) => view === ViewTypes.HISTORY;

const isRosterView = (view) => view === ViewTypes.ROSTER;

const isSeasonBySeasonRecordView = (view) => view === ViewTypes.SEASON_BY_SEASON_RECORD;

const isAllTimeRecordVsFranchiseView = (view) => view === ViewTypes.ALL_TIME_RECORD_VS_FRANCHISE;

export { ViewTypes as FranchisePages };

export default {
    ViewTypes,
    isHistoryView,
    isRosterView,
    isSeasonBySeasonRecordView,
    isAllTimeRecordVsFranchiseView,
};
